// src/components/PsicomotricidadeInfo.tsx
import React from 'react';
import '../../styles/especialidades.css';

const NeurologistaInfo: React.FC = () => (
    <section className="about_psicomotricidade">
        <div className="teste_zoom_two">
            <div className="about_text_psicomotricidade">
                <h2 className='sub_title'><b>Cuidar da alimentação é cuidar da vida.</b></h2>
<br />
<p>A nutrição é uma ciência fundamental para a promoção da saúde, do bem-estar físico e emocional e da prevenção de doenças. Mais do que prescrever dietas, o trabalho de um nutricionista envolve educação alimentar, escuta ativa e planejamento de uma alimentação saudável e personalizada, de acordo com as necessidades e objetivos de cada pessoa.</p>
<br />
<p>Por meio de uma abordagem individualizada, o nutricionista avalia o histórico clínico, hábitos alimentares, rotina e preferências do paciente, oferecendo orientações nutricionais práticas e sustentáveis. O foco não está apenas na estética ou em restrições alimentares, mas na construção de uma relação equilibrada com a comida e na melhoria da qualidade de vida em longo prazo.</p>
<br />
<p><b>Quando procurar um nutricionista?</b></p>
<br />
<p>O acompanhamento nutricional é indicado para:</p>
<br/>

  <li>Pessoas que desejam adotar uma alimentação saudável e melhorar hábitos alimentares;</li>
  <li>Quem busca emagrecimento saudável com foco na reeducação alimentar;</li>
  <li>Indivíduos com doenças crônicas, como diabetes, hipertensão, colesterol alto ou problemas digestivos;</li>
  <li>Pessoas com intolerâncias alimentares, alergias ou distúrbios gastrointestinais;</li>
  <li>Crianças, adolescentes, gestantes e idosos em fases de desenvolvimento ou transição;</li>
  <li>Praticantes de atividade física e atletas que buscam nutrição esportiva personalizada para desempenho e recuperação.</li>

<br />
<p><b>Benefícios da nutrição personalizada</b></p>
<br />
<p>Com a orientação de um nutricionista, é possível:</p>

  <li>Prevenir e controlar doenças por meio da alimentação equilibrada;</li>
  <li>Melhorar a disposição, o sono e o funcionamento intestinal;</li>
  <li>Fortalecer o sistema imunológico e a saúde mental;</li>
  <li>Desenvolver autonomia alimentar com foco em escolhas conscientes e sustentáveis;</li>
  <li>Criar um plano alimentar realista, prazeroso e ajustado ao seu estilo de vida.</li>

<br />
<p><b>Transforme sua alimentação, cuide da sua saúde</b></p>
<br />
<p>Mais do que seguir uma dieta, transformar a alimentação é um passo essencial para o autocuidado e o bem-estar integral. Um plano alimentar feito por um nutricionista qualificado respeita seu corpo, sua rotina e seus objetivos — e pode ser o ponto de partida para uma vida mais saudável e equilibrada.</p>

            </div>
        </div>
    </section>
);

export default NeurologistaInfo;